// extracted by mini-css-extract-plugin
export default {"pageContainer":"Documents_pageContainer__hApIz","hero_image":"Documents_hero_image__Y5k+X","header_border":"Documents_header_border__bsNc3"};